import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';
import Immutable from 'seamless-immutable';
import * as clientActions from '../actions/client';
import NotificationBanner from './boxes/NotificationBanner';
import Modal from './boxes/Modal';
import UpdateClientProfileForm from './forms/UpdateClientProfileForm';
import PreviousCards from './PreviousCards';
import LoadingScreen from './LoadingScreen';
import PageHeader from './boxes/PageHeader';
import PageBody from './boxes/PageBody';
import MainContent from './boxes/MainContent';
import PageNotFound from './PageNotFound';
// import COMPANY_STUB from '../company_icon.png';
import ImageInput from "./forms/inputs/ImageInput";
import { useTranslation, withTranslation } from 'react-i18next';


class ClientProfileComponent extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            openUpdateProfileModal:false,
            openPreviousCardsModal:false,
            clientLogo:""
        }
    }

    toggleUpdateProfileModal = () => {
          this.setState({
              openUpdateProfileModal: !this.state.openUpdateProfileModal
          })
    };

    togglePreviousCardsModal = () => {
        this.setState({
            openPreviousCardsModal: !this.state.openPreviousCardsModal
        })
    };

    renderLoading(){
        return (
            <MainContent>
                <PageBody>
                    <LoadingScreen/>
                </PageBody>
            </MainContent>
        )
    };

    onFormSubmit = (values, dispatch) => {
        const { user } = this.props;
        this.toggleUpdateProfileModal();
        dispatch(clientActions.updateClientProfile(
            values.email_address,
            values.phone_number,
            user.companyInfo.logo_filename,
            user.companyInfo.logoUrl,
            values.access_token,
            values.client_id
        ));
    };

    onImageUploaded = (img) => {
        const {dispatch, user} = this.props;
        this.setState({
            clientLogo:img
        });
        dispatch(clientActions.changeClientLogo(img,user.credentials.accessToken, user.companyInfo.id));
    };

        clearEmployeeNotifications = () => {
            this.props.dispatch(clientActions.clearNotifications());
        };


    render(){

        const { openUpdateProfileModal, openPreviousCardsModal, clientLogo } = this.state;

        const { isFetching, error, alert, user, invalidated, t  } = this.props;

        if ( error && error.code === 404 ) return <PageNotFound/>;

        if(!isFetching && invalidated) return window.location.reload(true);
        if(!isFetching && !invalidated)
        return (
            <MainContent>
                {openUpdateProfileModal &&
                    <UpdateClientProfileModal
                        onFormSubmit={this.onFormSubmit}
                        onClose={this.toggleUpdateProfileModal}
                        client={user.companyInfo}
                        accessToken={user.credentials.accessToken}/>
                }
                {openPreviousCardsModal &&
                    <PreviousCardsModal
                        onClose={this.togglePreviousCardsModal}
                        clientId={user.companyInfo.id}
                        accessToken={user.credentials.accessToken}/>
                }
                <PageHeader title={t("profile.profilePageTitle")}/>
                <PageBody>
                    {(!_.isEmpty(error) || alert) &&
                        <NotificationBanner
                            title={error.message ? t("common.errorNotificationTitle") : t("common.defaultNotificationTitle")}
                            message={error.message ? error.message : alert}
                            type={error.message ? "error" : "success"}
                            close={this.clearEmployeeNotifications}
                            />
                    }
                    <div className="button-header">
                        <button
                            className="primary_button"
                            onClick={this.togglePreviousCardsModal}>
                                <i className="fa fa-credit-card" style={{color:"white"}}/>
                                {'  '}
                                {t("profile.viewAdditionalPaymentMethodButtonText")}
                        </button>
                    </div>

                    <div className="dashboard_profile">
                        <div className="profile__img">
                            <ImageInput
                                width={250}
                                height={250}
                                onCropComplete={this.onImageUploaded}
                                placeholder={clientLogo || user.companyInfo.logoUrl}
                                cta={t("profile.imageUploadCtaText")}
                            />
                        </div>

                        <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                            <div style={{display:"flex", flexWrap:"wrap" }}>
                                <div className="profile__info">
                                    <p className="profile__label" >{t("profile.companyNameProfileInfo")}</p>
                                    <p className="profile__infotext">{`${user.companyInfo.name}`}</p>
                                    <p className="profile__label">{t("profile.addressProfileInfo")}</p>
                                    <p className="profile__infotext">{user.companyInfo.address}</p>
                                </div>
                                <div className="profile__info">
                                    <p className="profile__label" >{t("profile.emailAddressProfileInfo")}</p>
                                    <p className="profile__infotext">{`${user.companyInfo.email || 'N/A'}`}</p>
                                    <p className="profile__label">{t("profile.phoneNumberProfileInfo")}</p>
                                    <p className="profile__infotext">{`${user.companyInfo.phoneNumber|| 'N/A'}`}</p>
                                </div>
                            </div>
                            <button className="primary_button" onClick={this.toggleUpdateProfileModal}>{t("profile.profileEditSaveButtonText")}</button>
                        </div>
                        <br/>
                    </div>
                    {user.adminInfo.hasMultipleAccounts &&
                        <Link to={{
                            pathname: `/select-account`,
                            state: {
                                accounts: user.adminInfo.accounts,
                                accessToken: user.credentials.accessToken
                            }}}
                            style={{fontSize:"2rem",margin:"2rem"}}>
                            {t("profile.accountSelectionLink")}
                        </Link>
                    }
                </PageBody>
            </MainContent>
        );
        return this.renderLoading();
    }
}


const UpdateClientProfileModal = (props) => {
  const { t } = useTranslation();
  return (
      <Modal title={t("profile.updateClientProfileModalTitle")} onClose={props.onClose}>
          <UpdateClientProfileForm
              onSubmit={props.onFormSubmit}
              accessToken={props.accessToken}
              client={props.client}/>
      </Modal>
  )
};

const PreviousCardsModal = (props) => {
    const { t } = useTranslation();
    return (
        <Modal title={t("profile.previousCardModalTitle")} onClose={props.onClose}>
            <PreviousCards
                accessToken={props.accessToken}
                clientId={props.clientId}/>
        </Modal>
    )
  };

const mapStateToProps = ({client}) => {
    return {
    isFetching: client.isFetching,
    invalidated: client.invalidated,
    error: client.error ? Immutable.asMutable(client.error) : {},
    alert: client.alert
    }
};

const ClientProfileComponentWithTranslation = withTranslation()(ClientProfileComponent);
export default connect(mapStateToProps)(ClientProfileComponentWithTranslation);